import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL;

export const GloginApi = async (payload) => {
  const headers = {
    "Content-Type": "application/json",
    "Accept": "*",
  };
  return await axios.post(`${apiBaseUrl}/google-login`, payload, {
    headers,
  });
};
